import { useDroppable } from '@dnd-kit/react';
import { useRef } from 'react';
import type { z } from 'zod';
import type { zStepDropZoneData } from '~/hooks/step/useHandleMoveOperation';
import { AddStepContentPopover } from './newStep/AddStepContentPopover';

export default function NewStepControl({
  insertAfterStepIndex,
  testContentId,
  // Needed so that we know where to insert the new step
  insertAfterStepOrder,
  isLastStep,
  hide,
  disabled,
  prevStepId,
  nextStepId,
  activePageAlias,
}: {
  insertAfterStepIndex: number;
  // Maybe the testId could be optional
  testContentId: string;
  insertAfterStepOrder: number;
  isLastStep?: boolean;
  hide?: boolean;
  disabled?: boolean;
  prevStepId?: string;
  nextStepId?: string;
  activePageAlias?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const { isDropTarget } = useDroppable({
    id: insertAfterStepIndex,
    element: ref,
    data: { testContentId, insertAfterStepOrder, prevStepId, nextStepId } satisfies z.infer<typeof zStepDropZoneData>,
    disabled: hide || disabled,
  });

  const containerClasses = `relative z-50 flex justify-center transition-all w-full ${
    isDropTarget ? 'py-4' : 'py-0.5'
  }`;

  return (
    <div
      ref={ref}
      className={containerClasses}
    >
      {!hide && (
        <>
          {!!isDropTarget && (
            <div className="absolute inset-0 flex items-start pt-4">
              <hr className="w-full border-dashed border-blue-400" />
            </div>
          )}
          {/* For the last step, we move the menu a bit lower and also display the menu button even when it's drop zone */}
          {!!(!isDropTarget || isLastStep) && (
            <AddStepContentPopover
              testContentId={testContentId}
              isLastStep={isLastStep}
              disabled={disabled}
              insertAfterStepOrder={insertAfterStepOrder}
              insertAfterStepIndex={insertAfterStepIndex}
              key={nextStepId}
              activePageAlias={activePageAlias}
            />
          )}
        </>
      )}
    </div>
  );
}
